/**
 * @file loadscene.js
 * @desc This module contains LoadScene class definition.
 * @author Igor Kling <kling.igor.ksi@gmail.com>
 * @version 1.0.dev
 * @copyright 2016 (c) KSI Corporation
 * */

var Scene = require('scene').Scene;
var Animation = require('animation').Animation;

(/** @lends <global> */function (global) {
    'use strict';
    
    var loadBarWidth = 0;
    
    /**
     * Constructs LoadScene object.
     * @class
     * @constructor
     * @name LoadScene
     * @classdesc This is game preloader screen. Shows resources preloading progress and network connection indicator.
     * @extends {Scene}
     * @requires Scene
     * */
    var LoadScene = function(config) {
        Scene.call(this);
    
        this.loadScreen = new PIXI.Sprite(PIXI.utils.TextureCache["res/loadscreen.jpg"]);
        this.addChild(this.loadScreen);
        
        this.loadBar = new PIXI.Sprite(PIXI.utils.TextureCache["res/loadbar.png"]);
        loadBarWidth = this.loadBar.width;
        // progress bar initially is zero length
        this.loadBar.texture.frame.width = 0;
        this.loadBar.x = config.loadscreen.loadbar.position.x;
        this.loadBar.y = config.loadscreen.loadbar.position.y;
        this.addChild(this.loadBar);

        this.connectionIndicator = new PIXI.Sprite(PIXI.utils.TextureCache["res/network_indicator.png"]);
        this.connectionIndicator.position.set(config.resolution.width / 2, config.resolution.height / 2);
        this.connectionIndicator.anchor.set(0.5, 0.5);
        this.addChild(this.connectionIndicator);
    
        var self = this;
        
        var connectionIndicatorRotation = {angle:0};
        
        this.connectionIndiactorRotationTween = new TWEEN.Tween(connectionIndicatorRotation)
            .to({ angle: '-' + Math.PI/2}, 200)
            .onUpdate(function () {
                var angle = ((connectionIndicatorRotation.angle * 180 / Math.PI) / 45 | 0) * 45 * Math.PI / 180;
                self.connectionIndicator.rotation = angle;
            })
            .onComplete(function() {
                if (Math.abs(self.connectionIndicator.rotation) >= 2 * Math.PI) {
                    self.connectionIndicator.rotation = self.connectionIndicator.rotation % (2 * Math.PI);
                }
            })
            .repeat(Infinity)
            .start();
        
        
        if (config.loadscreen.music) {
            
            this.loadSound = new Howl({
                src: [config.loadscreen.music],
                autoplay: true,
                // preload : true,
                html5: true,
                loop: false,
                volume: 0.5
            });
            this.loadSound.loop(false);
            if (config.loadscreen.musicLoop) {
                this.loadSound.loop(config.loadscreen.musicLoop);
            }
            // this.loadSound.play();
        }
    };
    
    LoadScene.prototype = Object.create(Scene.prototype);
    
    LoadScene.prototype.constructor = LoadScene;
    
    LoadScene.prototype.destroy = function(textures, baseTextures) {
    
        console.log('LOAD SCENE DESTROY (' + textures  + " " + baseTextures + ")");
        
        Scene.prototype.destroy.call(this, textures, baseTextures);
        
        this.loadScreen = null;
        this.loadBar = null;
        this.connectionIndicator = null;

        if (this.loadSound) {
            this.loadSound = null;
        }
    
        // PIXI.utils.TextureCache["res/loadscreen.jpg"].destroy(true);
        // PIXI.utils.TextureCache["res/loadbar.png"].destroy(true);

    };
    
    
    /**
     * Hides network connection indicator.
     * */
    LoadScene.prototype.hideConnectionIndicator = function () {
        if (this.connectionIndiactorRotationTween) {
            this.connectionIndiactorRotationTween.stop();
            this.connectionIndiactorRotationTween = null;
        }

        this.connectionIndicator.visible = false;
    };
    
    
    /**
     * Update load progress indicator.
     * @param {Number} progress [0.0 - 1.0] where 1.0 means fully loaded game
     * */
    LoadScene.prototype.updateProgress = function (progress) {
        if (progress >= 0.99) {
            progress = 1.0;
            if (this.loadSound) {
                this.loadSound.loop(false);
                this.loadSound.fade(0.5, 0, 500);
            }
        }
        
        this.loadBar.texture.frame.width = loadBarWidth * progress;
        this.loadBar.texture._updateUvs();
    };
    
    global.LoadScene = LoadScene;
}(typeof module === 'object' && module.exports || this));



//////////////////
// WEBPACK FOOTER
// ./src/library/loadscene.js
// module id = 70
// module chunks = 0